import ErrorCodes from './ErrorCodes';

const ErrorCodesMessages: Record<ErrorCodes, string> = {
	[ErrorCodes.UNEXPECTED_EXCEPTION]: 'Unexpected exception',
	[ErrorCodes.FILE_IS_NOT_JS_OBJECT]: 'File needs to be object',
	[ErrorCodes.FILE_DOES_NOT_HAVE_UID]: 'File uid needs to be defined',
	[ErrorCodes.FILE_FLAGS_ARE_NOT_IN_ARRAY]: 'File flags needs to be Array of objects',
	[ErrorCodes.FILE_FLAG_IS_NOT_OBJECT]: 'File flag needs to be object',
	[ErrorCodes.COMMAND_TYPE_NOT_VALID]: 'Type contains invalid characters.',
	[ErrorCodes.COMMAND_TYPE_IS_TOO_LONG]: 'Type is longer then 100 characters.',
	[ErrorCodes.HARDWARE_LED_COLOR_IS_NOT_STRING]: 'Color must be string',
	[ErrorCodes.HARDWARE_LED_COLOR_IS_NOT_VALID]: 'Color must be in format #000000 or null',
	[ErrorCodes.FILE_NOT_FOUND_IN_CACHE]: 'File was not found',
	[ErrorCodes.OFFLINE_CACHE_UID_NOT_VALID]: 'Uid contains invalid characters',
	[ErrorCodes.OFFLINE_CACHE_HEADERS_NOT_VALID]: 'Invalid headers',
	[ErrorCodes.STREAM_INVALID_PROTOCOL_TYPE]: 'Invalid stream protocol type',
	[ErrorCodes.VIDEO_WAS_NOT_PLAYED_YET]: 'This video was not played yet',
	[ErrorCodes.VIDEO_WAS_STOPPED_ALREADY]: 'This video was already stopped',
	[ErrorCodes.SECURITY_PIN_CODE_INVALID]: 'Invalid PIN code',
};

export default ErrorCodesMessages;
